
<ng-container *ngIf="!(isLoading$ | async) && (pendingPaymentRequests$ | async) as paymentRequests">
  <div *ngIf="paymentRequests.length > 0  else noCapitalCall" class="capital-calls-list" id="payment-requests">
    <div *ngFor="let paymentRequest of paymentRequests" class="capital-call-info">
      <terra-lp-capital-call-details [paymentRequest]="paymentRequest" (achDebitPaymentRequestCompleted)="refresh()">
      </terra-lp-capital-call-details>
    </div>
  </div>

  <ng-template #noCapitalCall>
    <p class="empty-list-message">
      No pending capital calls at the moment.
    </p>
  </ng-template>
</ng-container>

<terra-loader *ngIf="isLoading$ | async" class="loader"></terra-loader>
